"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleActions = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ArticleAction_1 = require("./ArticleAction");
/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
let ArticleActions = class ArticleActions extends vue_property_decorator_1.Vue {
};
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: true }),
    __metadata("design:type", Array)
], ArticleActions.prototype, "actions", void 0);
ArticleActions = __decorate([
    vue_property_decorator_1.Component({
        name: 'ArticleActions',
        components: { ArticleAction: ArticleAction_1.ArticleAction },
        template: `
    <ul class="article-actions list-inline mb-0">
      <li v-for="action in actions" :key="action.icon"
          class="article-actions__item list-inline-item"
          :class="{ 'd-none d-lg-inline-block': action.hideForMobile }">
        <ArticleAction v-bind="action" />
      </li>
    </ul>
  `
    })
], ArticleActions);
exports.ArticleActions = ArticleActions;
//# sourceMappingURL=ArticleActions.js.map